module.exports = __webpack_public_path__ + "img/0x2cd67e977a493b392f67cd507e14fc3994177189.629f6db3.png";